<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>菜品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="分类名称：">
              <el-select size="small" v-model="listParams.plaGoodCategoryId" style="width: 100%" clearable>
                <el-option v-for="item in categoryNameList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="resetAndLoad"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result :page-sizes="[30]" :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <el-button :disabled="releaseArr.length === 0" class="align-left" type="success" size="small" @click="releaseDishes(false)"> 发布菜品 </el-button>
          <el-button class="align-left" type="primary" size="small" @click="releaseDishes(true)"> 发布所有菜品 </el-button>
          <el-button class="align-left" type="primary" size="small" @click="exporttDishList()"> 导出菜品价格清单 </el-button>

          <span class="table-info-display">
            <el-button style="margin-right: 10px" type="text" @click="linkToReleaseRecordPage">发布记录</el-button>
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table ref="table" slot="content" :data="tableData" max-height="800" @selection-change="handleSelectionChange" @selection-all="handleSelectionChange" border>
        <el-table-column align="center" type="selection" width="55"> </el-table-column>

        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

        <el-table-column prop="goodCategoryName" align="center" label="分类名称"> </el-table-column>

        <el-table-column prop="picture" align="center" label="图片">
          <template slot-scope="scope">
            <div class="wrap-picture-style">
              <img :src="scope.row.picture" alt="" />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" label="菜品名称"> </el-table-column>

        <el-table-column prop="goodSpecName" align="center" label="规格(g)"> </el-table-column>

        <el-table-column prop="pieceUnit" align="center" label="计价方式">
          <template slot-scope="scope">
            <span v-if="scope.row.pieceUnit === 0">计重</span>
            <span v-if="scope.row.pieceUnit === 1">计件</span>
          </template>
        </el-table-column>

        <el-table-column prop="price" align="center" label="单价(元)">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleShowPrice(row, 1)">{{ row.price }}</el-button>
          </template>
        </el-table-column>

        <el-table-column v-if="listParams.supplyId === '3'" prop="referencePrice" align="center" label="参考价(元)">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleShowPrice(row, 2)">{{ row.price }}</el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
            <el-button type="text" @click="submitHistory(scope.row.id)">历史提交记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="领货日期：">
            <el-select clearable style="width: 100%" v-model="itemParams.supplyDateId" placeholder="请选择领货日期" size="small">
              <el-option v-for="item in dateList" :value="item.id" :key="item.id" :label="item.title"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="confirmRelease"> 确认发布 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <DialogHistory :dialogVisible.sync="historyDialogVisible" :id="historyId" />

    <DialogPrice :dialogVisible.sync="dialogVisiblePrice" :doalogData="dialogPriceData" @refresh="loadTableData([])" />
  </div>
</template>

<script>
import { download } from "../../../../../utils/javascript/download";
import DialogHistory from "./components/DialogHistory";
import DialogPrice from "./components/DialogPrice";

export default {
  components: { DialogHistory, DialogPrice },
  data() {
    return {
      listParams: {
        supplyId: "",
        plaGoodCategoryId: "",
      },
      categoryNameList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 30,
        total: 0,
      },
      dialogTitle: "编辑菜品管理",
      dialogVisible: false,
      historyDialogVisible: false,
      historyId: "",
      itemParams: {
        supplyDateId: "",
        supplyId: "",
      },
      dateList: [],
      checkItemParams: {
        supplyDateId: [{ required: true, message: "请选择发布日期", trigger: "change" }],
      },
      isDisabled: false,
      releaseArr: [],
      releaseArrTotal: {},
      pageVal: 0,
      publishStatus: false,
      allGoodIdList: "",
      dialogVisiblePrice: false,
      dialogPriceData: {},
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadCategoryList();
    this.loadTableData([]);
  },
  methods: {
    /***
     * 历史调价记录
     */
    submitHistory(id) {
      this.historyId = id;
      this.historyDialogVisible = true;
    },
    /**
     * 导出菜品价格清单
     */
    exporttDishList() {
      const exportParams = {
        supplyId: this.listParams.supplyId,
        plaGoodCategoryId: this.listParams.plaGoodCategoryId,
      };
      // this.$router.open({
      //   path: "/api/web/good/gooddetail/export",
      //   query: exportParams,
      //   type: "excel"
      // });

      download("/good/gooddetail/export", exportParams, "菜品清单");
    },
    /**
     * 展示价格
     */
    handleShowPrice(obj, type) {
      this.dialogPriceData = {
        type,
        id: obj.id,
        price: obj.price,
        goodLevelPrices: JSON.parse(JSON.stringify(obj.goodLevelPrices)),
      };
      this.dialogVisiblePrice = true;
    },
    /**
     * 初始化加载分类名称
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/good/goodcategory/findAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const dataList = res.body.data;
            dataList.unshift({ id: "", title: "全部" });
            this.categoryNameList = dataList;
          } else {
            this.categoryNameList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData(arr) {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/good/gooddetail/findByPage",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          plaGoodCategoryId: this.listParams.plaGoodCategoryId,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
              this.pager.pageIndex = res.body.data.pageIndex;
              this.pager.pageSize = res.body.data.pageSize;
              this.allGoodIdList = res.body.data.allGoodIdList;
              const rows = [];
              if (this.tableData.length > 0 && this.releaseArr.length > 0) {
                this.tableData.map((item, index) => {
                  arr.map((item1, index1) => {
                    if (item.id === item1) {
                      rows.push(item);
                    }
                  });
                });
              }
              setTimeout(() => {
                rows.forEach(row => {
                  this.$refs.table.toggleRowSelection(row);
                });
              }, 500);
              // this.$refs.table.toggleRowSelection(res.body.data.dataList[0], true);
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 每次点击查询按钮重置页码
     */
    resetAndLoad() {
      this.pager.pageIndex = 1;
      this.loadTableData([]);
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.$router.push({
        name: "addDishes",
      });
    },
    /**
     * checkbox的change事件
     * @param selection
     */
    handleSelectionChange(selection) {
      this.releaseArr = [];
      selection.map(item => {
        this.releaseArr.push(item.id);
      });
    },
    /**
     * 发布菜品
     * @param isAll
     */
    releaseDishes(isAll) {
      if (isAll) {
        this.publishStatus = true;
      } else {
        this.publishStatus = false;
      }
      this.dialogVisible = true;
      this.loadDateList();
    },
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/good/supplydate/findAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dateList = res.body.data;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pageVal = val;
      let $index = this.pager.pageIndex;
      // 表明checkbox总数据在当前页码是有数据的
      if ($index > 1) {
        $index = $index - 1;
      } else {
        $index = 0;
      }
      const assignObject = {};
      assignObject[$index] = this.releaseArr;
      Object.assign(this.releaseArrTotal, assignObject);
      this.pager.pageIndex = this.pageVal;
      if (this.releaseArrTotal[this.pageVal - 1] && this.releaseArrTotal[this.pageVal - 1].length > 0) {
        this.loadTableData(this.releaseArrTotal[this.pageVal - 1]);
      } else {
        this.loadTableData([]);
      }
    },
    /**
     * 跳转至发布记录页
     */
    linkToReleaseRecordPage() {
      this.$router.push({
        name: "releaseRecord",
      });
    },
    /**
     * 发布菜品
     */
    confirmRelease() {
      this.isDisabled = true;
      let $index = this.pager.pageIndex;
      if ($index > 1) {
        $index = $index - 1;
      } else {
        $index = 0;
      }
      const assignObject = {};
      assignObject[$index] = this.releaseArr;
      Object.assign(this.releaseArrTotal, assignObject);

      let releaseArr = [];
      for (const i in this.releaseArrTotal) {
        releaseArr = releaseArr.concat(this.releaseArrTotal[i]);
      }
      const bodyParams = Object.assign({}, this.itemParams, {
        goodIds: releaseArr,
      });
      bodyParams.goodIds = bodyParams.goodIds.join(",");
      // 一键发布所有菜品
      if (this.publishStatus) {
        bodyParams.goodIds = this.allGoodIdList;
      }
      bodyParams.supplyId = parseInt(this.$route.params.supplyId);
      this.$refs.dialogForm.validate(valid => {
        if (valid) {
          this.$http({
            url: global.apiUrl + "/good/supplygood",
            method: "POST",
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.$message.success(res.body.info);
                this.loadTableData([]);
              } else {
                this.isDisabled = false;
                this.dialogVisible = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },

    /**
     * 修改条目数据
     * @param id
     */
    editItem(id) {
      this.$router.push({
        name: "addDishes",
        query: {
          id: id,
        },
      });
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/good/gooddetail?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.releaseArr.map((item, index) => {
              if (item === id) {
                this.releaseArr.split(index, 1);
              }
            });
            this.loadTableData([]);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .wrap-picture-style {
    width: 100px;
    height: 60px;
    position: relative;
    overflow: hidden;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
